// @react/hooks/useSecretAudit.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { secretAuditStore } from '@core/stores';

/**
 * React hook for  operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSecretAudit } from '@react/hooks';
 *
 * const List = observer(() => {
 *   const store = useSecretAudit();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSecretAudit() {
  return secretAuditStore;
}
